module.exports = __webpack_public_path__ + "img/public.18478418.jpg";